// Admin API client — /admin/ai-apis/* (mirrors the API's ai-apis aggregate, A7Y-5559).

import type {
  AiApiModelCatalogResponse,
  AiApiProvider,
  AiApiProviderMonthDetailResponse,
  AiApiProviderMonthsResponse,
  AiApisOverviewResponse,
} from '@a7y/types';
import type { QueryShape } from '@/pages/audit-spend/types';
import { client, adminQueryUrl } from './transport';

/**
 * Every ai-apis response: `data`, the BigQuery statement behind it (absent on
 * `/models`, which is read through the functions proxy), when that statement
 * ran, and which cache tier answered.
 */
export interface AiApisEnvelope<T> {
  data: T;
  query?: QueryShape;
  generated_at?: string;
  cache?: 'memory' | 'kv' | 'fresh';
}

export const aiApisApi = {
  // Every endpoint is cached server-side for 24h (source: KV_TTL_SEC, a7y-api audit_spend_cache.ts); `force` bypasses it.
  getAiApisOverview: (params?: { months?: number; force?: boolean }) =>
    client.get<AiApisEnvelope<AiApisOverviewResponse>>(
      adminQueryUrl('/ai-apis/overview', { months: params?.months, force: params?.force })
    ),
  getAiApiProviderMonths: (provider: AiApiProvider, params?: { force?: boolean }) =>
    client.get<AiApisEnvelope<AiApiProviderMonthsResponse>>(
      adminQueryUrl(`/ai-apis/providers/${provider}/months`, { force: params?.force })
    ),
  getAiApiProviderMonth: (provider: AiApiProvider, month: string, params?: { force?: boolean }) =>
    client.get<AiApisEnvelope<AiApiProviderMonthDetailResponse>>(
      adminQueryUrl(`/ai-apis/providers/${provider}/months/${month}`, { force: params?.force })
    ),
  getAiApiModels: () => client.get<AiApisEnvelope<AiApiModelCatalogResponse>>('/ai-apis/models'),
};
